import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AsyncPipe, NgIf} from "@angular/common";
import {Store} from "@ngrx/store";
import * as AccountActions from '../../../../state/account/account.actions';
import * as AccountSelectors from '../../../../state/account/account.selectors';
import {Router} from "@angular/router";
import {PopupService} from "../../../../services/popup.service";
import { logout } from '../../../../state/auth/auth.actions';
import {AuthService} from "../../../../services/auth.service";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {Observable} from "rxjs";
import {AccountState} from "../../../../state/account/account.reducer";

@Component({
  selector: 'app-account-cancellation',
  standalone: true,
  imports: [
    NgIf,
    AsyncPipe,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './account-cancellation.component.html',
  styleUrl: './account-cancellation.component.scss'
})
export class AccountCancellationComponent {
  @Input() isVisible: boolean = false;
  @Output() modalClosed: EventEmitter<void> = new EventEmitter();

  form: FormGroup;

  loading$: Observable<boolean>;

  constructor(
    public formBuilder: FormBuilder,
    private router: Router,
    private popupService: PopupService,
    private authService: AuthService,
    private store: Store<{ account: AccountState }>
  ) {

    this.form = formBuilder.group(
      {
        password: ['', [Validators.required]]
      },
      { updateOn: "blur" }
    );

    this.loading$ = this.store.select(state => state.account.isPasswordValidating);

  }

  closeModal() {
    this.isVisible = false;
    this.modalClosed.emit(); // Notify the parent component that the modal has been closed
  }

  onDeleteAccount(): void {
    console.log('onDeleteAccount')

    if(this.form.valid) {

      const password = this.form.value.password;
      this.validatePassword(password)

    }
  }

  validatePassword(password: string) {

    this.store.dispatch(AccountActions.validatePassword({ password }));

    this.store.select(AccountSelectors.selectValidationMessage).subscribe(message => {
      if (message) {
        console.log('Validation success message:', message);

        this.deleteAccount()

        // this.popupService.notify('Password is valid!', 'Validation Success', 'success');
      }
    });

    this.store.select(AccountSelectors.selectValidationError).subscribe(error => {
      if (error) {
        console.error('Validation error:', error);
        this.popupService.notify(error, 'Validation Error', 'error');
      }
    });

  }

  deleteAccount() {

    this.store.dispatch(AccountActions.deleteAccount());

    this.store.select(AccountSelectors.selectDeleteMessage).subscribe(message => {
      if (message) {
        console.log('Deletion success message:', message);

        this.authService.logout();

        this.router.navigate(['/account-cancellation-successful']);

        this.popupService.notify('User was successfully deleted!', 'User deleted', 'success');
      }
    });

    this.store.select(AccountSelectors.selectDeleteError).subscribe(error => {
      if (error) {
        console.error('Deletion error:', error);
      }
    });

  }

}
